import { makeStyles } from '@material-ui/core/styles';
import { ICheckoutTheme } from '../../../../common/theme/ICheckoutTheme';

export type ICarImageClasses = 'image';

const carImageStyles = makeStyles<ICheckoutTheme, ICarImageClasses>(
  () => ({
    image: {
      width: '100%',
      maxWidth: '500px',
      margin: '0 auto',
      display: 'block',
    },
  }),
  { name: 'Summary_CarImage' },
);

export default carImageStyles;
